import * as React from 'react';

import { cn } from '@/lib/utils';

// shadcn/ui Textarea — écrit à la main (pas de CLI, lockfile figé). Tokens
// sémantiques uniquement (P-06 / WCAG AA) : aucune couleur en dur. Focus visible
// homogène (ring) pour la navigation clavier (WCAG 2.4.7). Multi-lignes : édition
// des paramètres de type Chaine (templates de messagerie, DBU §2.8 l.1920-1926).
const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => {
  return (
    <textarea
      ref={ref}
      className={cn(
        'flex min-h-32 w-full rounded-md border border-input bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-destructive aria-[invalid=true]:ring-destructive',
        className,
      )}
      {...props}
    />
  );
});
Textarea.displayName = 'Textarea';

export { Textarea };
